import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconHouse(props: SvgIconProps) {
  return (
    <SVGIcon width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M3 7H7V15H4C3.44772 15 3 14.5523 3 14V7Z" stroke="currentColor" strokeWidth="2" />
      <path d="M7 7H17V14C17 14.5523 16.5523 15 16 15H7V7Z" stroke="currentColor" strokeWidth="2" />
      <path d="M4 1L1 7H7L4 1Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
      <path d="M16 1H4L7 7H19L16 1Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
      <path d="M12 10V15" stroke="currentColor" strokeWidth="2" />
    </SVGIcon>
  );
}
